/*
 * This file is part of Mitei Server.
 * Copyright (c) 2019 f0reachARR <f0reach@f0reach.me>
 *
 * Mitei Server is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * Mitei Server is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Mitei Server.  If not, see <http://www.gnu.org/licenses/>.
 */
import * as React from 'react';
import { ConfirmDialogContextProvider, ConfirmDialogView, } from './ConfirmDialog';
import { MessageDialogContextProvider, MessageDialogView, } from './MessageDialog';
import { MessageSnackContextProvider, MessageSnackView } from './MessageSnack';
export const MessageView = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(MessageSnackView, null),
        React.createElement(MessageDialogView, null),
        React.createElement(ConfirmDialogView, null)));
};
export const MessageProvider = ({ children }) => {
    return (React.createElement(MessageSnackContextProvider, null,
        React.createElement(MessageDialogContextProvider, null,
            React.createElement(ConfirmDialogContextProvider, null, children))));
};
//# sourceMappingURL=index.js.map